export default __webpack_public_path__ + "static/media/IMG KDO@2x.ed54c00c.png";